<template>
  <div class="flex flex-col">
    <div class="label">{{ $t('documentation.api.contentType') }}</div>
    <div v-if="hasMoreThanOneType">
      <div :id="id" class="pill content-type select monospace flex gap-[8px]" @click="open = !open">
        {{ selectedType }}
        <v-icon class="icon" name="down" :size="-6" />
      </div>
      <div class="text-center">
        <v-menu :anchor="id" fixed :open="open" auto-dismiss>
          <v-menu-item
            v-for="(type, idx) in types"
            :key="type"
            class="monospace"
            :value="`${type}`"
            :text="type"
            @click="
              open = !open;
              index === idx;
              onSelected(idx);
            "
          >
          </v-menu-item>
        </v-menu>
      </div>
    </div>

    <div v-else class="pill content-type monospace">{{ selectedType }}</div>
  </div>
</template>

<script setup lang="ts">
import { VIcon, VMenuItem, VMenu } from '@vonage/vivid-vue';
import { computed, PropType, ref } from 'vue';

const props = defineProps({
  id: { type: String, required: true },
  types: { type: Array as PropType<string[]>, required: true },
});
const emit = defineEmits(['selected']);

const index = ref(0);
const hasMoreThanOneType = computed(() => props.types.length > 1);
const selectedType = computed(() => props.types[index.value]);

const onSelected = (idx: number) => {
  index.value = idx;
  emit('selected', idx);
};

const open = ref(false);
</script>

<style scoped lang="scss">
@use 'sass:color';

.label {
  letter-spacing: 1px;
  text-align: right;
  font: var(--dev-docs-api-content-type-label-font);
}

.content-type {
  padding: 4px 8px !important;
  font: var(--dev-docs-api-content-type-font);
  text-transform: none !important;

  background-color: theme('colors.blue.500');
  color: var(--vvd-color-canvas);

  &.select {
    cursor: pointer;
    &:hover {
      background-color: color.adjust(#0098e8, $lightness: 10%);
    }
  }

  .icon {
    color: var(--vvd-color-canvas);
    margin-left: 2px;
    margin-top: -2px;
  }
}
</style>
